"use client";

import type { ReactNode } from "react";
import { Box } from "@chakra-ui/react";

interface FieldProps {
  label?: string;
  htmlFor?: string;
  srOnly?: boolean;
  children: ReactNode;
}

export function Field({ label, htmlFor, srOnly = false, children }: FieldProps) {
  return (
    <Box w="full">
      {label && (
        <Box
          as="label"
          // @ts-expect-error - htmlFor is a valid HTML attribute for label elements
          htmlFor={htmlFor}
          display="block"
          fontSize="sm"
          fontWeight="medium"
          color="gray.700"
          mb={1}
          srOnly={srOnly}
        >
          {label}
        </Box>
      )}
      {children}
    </Box>
  );
}
